import { render, staticRenderFns } from "./projectsList.vue?vue&type=template&id=7e4bb6a4&"
import script from "./projectsList.vue?vue&type=script&lang=js&"
export * from "./projectsList.vue?vue&type=script&lang=js&"
import style0 from "./projectsList.vue?vue&type=style&index=0&id=7e4bb6a4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports